<app-navbar/>
<header class="d-flex flex-column justify-content-between w-100"
        [style]="backgroundImage() ? {'background-image': `url(${backgroundImage()})`} : {}">
  <div class="text-center" [class.content-image]="!!backgroundImage()" [class.content-color]="!backgroundImage()">
    <h1 class="mt-0 text-white">{{ title() }}</h1>
    @if (description(); as desc) {
      <p class="text-white">{{ desc }}</p>
    }
  </div>
</header>
